var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uiNotice bg-white",class:{ 'priority': _vm.priority },on:{"click":_vm.click}},[_c('div',{staticClass:"uiNotice__label"},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]),(_vm.body)?_c('div',{staticClass:"uiNotice__body"},[_vm._v("\n    "+_vm._s(_vm.body)+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }